var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{attrs:{"id":"back-30s"},on:{"click":_vm.back30s}}),_c('button',{attrs:{"id":"fs-laptop"}})])}
var staticRenderFns = []

export { render, staticRenderFns }